import { popupModel } from '@_entities/system';

interface PopupTimeInfo {
	id: popupModel.TPopup['id'];
	expireTime: string; // ISO 문자열 형식
}

const POPUP_STORAGE_KEY = 'popup-time-info';

// localStorage에서 팝업 정보 가져오기
function getPopupTimeInfo(): PopupTimeInfo[] {
	const stored = localStorage.getItem(POPUP_STORAGE_KEY);
	return stored ? JSON.parse(stored) : [];
}

// localStorage에 팝업 정보 저장
function setPopupTimeInfo(popups: PopupTimeInfo[]): void {
	localStorage.setItem(POPUP_STORAGE_KEY, JSON.stringify(popups));
}

// 팝업이 표시되어야 하는지 확인
export function shouldShowPopup(popupId: popupModel.TPopup['id']): boolean {
	const popups = getPopupTimeInfo();
	const popup = popups.find((p) => p.id === popupId);

	const currentTime = new Date().getTime();

	if (!popup) {
		// 새로운 팝업 정보 추가
		popups.push({ id: popupId, expireTime: new Date().toISOString() });
		setPopupTimeInfo(popups);
		return true;
	}

	const popupExpireTime = new Date(popup.expireTime).getTime();

	return currentTime > popupExpireTime;
}

// 현재 활성화된 팝업 목록 동기화
export function syncActivePopups(activePopupIds: popupModel.TPopup['id'][]): void {
	const popups = getPopupTimeInfo();

	const updatedPopups = popups.filter((popup) => activePopupIds.includes(popup.id));

	setPopupTimeInfo(updatedPopups);
}

// 특정 팝업 정보 업데이트
export function updatePopupTime(popupId: popupModel.TPopup['id'], newExpireTime: string): void {
	const popups = getPopupTimeInfo();
	const popupIndex = popups.findIndex((p) => p.id === popupId);

	if (popupIndex !== -1) {
		const newExpireDateTime = new Date(newExpireTime).getTime();
		const storeExpireDateTime = new Date(popups[popupIndex].expireTime).getTime();

		if (newExpireDateTime > storeExpireDateTime) {
			popups[popupIndex].expireTime = newExpireTime;
		}
	} else {
		popups.push({ id: popupId, expireTime: newExpireTime });
	}

	setPopupTimeInfo(popups);
}

export function handleDontShow(popupId: popupModel.TPopup['id'], dontShowDuration: number) {
	const currentTime = new Date();
	currentTime.setHours(currentTime.getHours() + dontShowDuration);
	updatePopupTime(popupId, currentTime.toISOString());
}

export function closePromotionPopup(popupId: popupModel.TPopup['id']) {
	const currentTime = new Date();
	currentTime.setHours(currentTime.getHours() + 1);
	updatePopupTime(popupId, currentTime.toISOString());
}

export function handleOnPopupButtonClick(
	button: popupModel.TButton,
	handleClose: () => void,
	popupId: popupModel.TPopup['id'],
) {
	if (button.type === 'close') {
		closePromotionPopup(popupId);
		handleClose();
	} else if (button.type === 'redirect-page') {
		window.location.href = button.redirectURL;
	} else {
		handleDontShow(popupId, button.dontShowDuration);
		handleClose();
	}
}
